export default function findKey(obj, fn) {
  for (let key in obj) {
    if (!obj.hasOwnProperty(key)) {
      return;
    }
    if (fn(obj[key])) {
      return key;
    }
  }
}